// components/InlineAlert.tsx
import React, { useEffect, useState } from "react";

type AlertType = "success" | "error";

interface InlineAlertProps {
  type: AlertType;
  message: string;
  duration?: number;
  onClose?: () => void;
}

const alertStyles = {
  success: {
    bg: "bg-green-100",
    border: "border-green-400",
    text: "text-green-800",
  },
  error: {
    bg: "bg-red-100",
    border: "border-red-400",
    text: "text-red-800",
  },
};

const InlineAlert: React.FC<InlineAlertProps> = ({
  type,
  message,
  duration = 4000,
  onClose,
}) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      onClose?.();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  if (!visible) return null;

  const { bg, border, text } = alertStyles[type];

  return (
    <div
      className={`w-full p-4 mb-4 rounded-md border ${bg} ${border} ${text} transition-opacity duration-300 animate-fade-in`}
    >
      {message}
    </div>
  );
};

export default InlineAlert;
